export const INSURANCE_COVERAGE_REQUIREMENT_EVENT = {
  UploadCoverage: "UploadCoverage",
  SubmitCoverage: "SubmitCoverage",
  ShareInformation: "ShareInformation"
} as const;
